module.exports = __webpack_public_path__ + "img/app_customers_say_03.a2d65e4e.jpg";